import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Button, Accordion, Card } from "react-bootstrap";
import Question from "./question";
import Answer from "./answer";
import ReportAdmin from "./reportadmin";
import { useNavigate } from "react-router-dom";
import Moment from "moment";
import { imgPath } from "../../utils/imagePath";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { getDatabase, ref, get, child, set } from "firebase/database";
import { renderGlobalModal } from "../../utils/helpers";
import { loadCategoryData, loadForumData, loadForumUserData, saveForumUser, saveForumAnswerLike } from "./Slice/forumSlice";

const Index = () => {

  const history = useNavigate();
  const [room, setRoom] = useState({ roomname: "" });
  let forum_heading = "";

  const dispatch = useDispatch();
  const { categories, forums, forumusers } = useSelector((state) => state?.forum);
  const isAuth = useSelector((state) => state?.isAuth);
  const userInfo = useSelector((state) => state?.userInfo || {});
  const setting = useSelector((state) => state?.setting);

  if (userInfo?.role_id == "Mentor") {
    forum_heading = "Mentors";
  } else if (userInfo?.role_id == "Mentees") {
    forum_heading = "Mentees";
  }

  const siteName = setting?.name?.trim() || "Forum";

  useEffect(() => {
    const title = `${siteName} - Forum`;

    document.title = title;

    if (isAuth && userInfo?.id) {
      dispatch(loadCategoryData());
      dispatch(loadForumData(userInfo.id));
      dispatch(saveForumUser(userInfo?.id));
      dispatch(loadForumUserData(userInfo.role_id));
    } else {
      renderGlobalModal({
        message: "Thank you for browsing! Help us create a meaningful mentoring engagement for you by registering or logging in."
      });
      console.warn("User not authenticated — skipping forum user save");
    }
    // If user is redirected to chat room
    if (room.roomname) {
      history("/chat?roomKey=" + room.roomname);
    }
  }, [siteName, room, history, dispatch, isAuth, userInfo]);

  const [disbaled] = useState("join-bt-active");
  const [modalShow, setModalShow] = useState(false);
  const [userData, setUserData] = useState({});
  const [answerShow, setAnswerShow] = useState(false);
  const [reportModalShow, setReportModalShow] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [activeId, setActiveId] = useState(["1"]);

  const askQuestionModal = (e) => {
    if (localStorage.isConfirmed == "true") {
      dispatch(loadCategoryData());
      e.preventDefault();
      setModalShow(true);
      setUserData({
        user_id: userInfo.id,
        categories: categories,
      });
    } else {
      setPopupMessage("Please Complete Your Profile First.");
      setShowPopup(true);
    }
  };

  const replyAnswerModal = (e, ques_id, user_ans) => {
    e.preventDefault();
    setAnswerShow(true);
    setUserData({
      ques_id,
      user_id: userInfo?.id,
      user_ans,
    });
  };

  const viewReportModal = (e, ques_id, ans_id, report_type) => {
    e.preventDefault();
    setReportModalShow(true);
    setUserData({
      user_id: userInfo.id,
      ques_id: ques_id,
      ans_id: ans_id,
      report_type: report_type,
    });
  };

  const likeAnswer = async (ques_id, ans_id) => {
    const ans_params = {};
    ans_params.user_id = userInfo.id;
    ans_params.ques_id = ques_id;
    ans_params.ans_id = ans_id;
    const result = await dispatch(saveForumAnswerLike(ans_params)).unwrap();
    // Show popup message (success or error)
    setPopupMessage(result.message);
    setShowPopup(true);
  };

  const prepareHtml = (description) => {
    return { __html: description || "" };
  };

  const handleClickChat = async (item) => {
    if (!isAuth) {
      setPopupMessage(
        "Thank you for browsing! Help us create a meaningful mentoring engagement for you by registering in one simple step, or login if you already have an account."
      );
      setShowPopup(true);
      history(`/login`);
      return;
    }
    if (localStorage.isConfirmed !== "true") {
      setPopupMessage("Please Complete Your Profile First.");
      setShowPopup(true);
      return;
    }
    // Create consistent room key
    const roomUser =
      userInfo.id > item.user_id
        ? `${userInfo.id}_${item.user_id}`
        : `${item.user_id}_${userInfo.id}`;

    const time = Moment.utc().valueOf();
    const message = {
      mentor_name: item.full_name,
      mentor_image: item.image,
      mentor_id: item.user_id,
      mentee_name: userInfo.full_name,
      mentee_image: userInfo.image,
      mentee_id: userInfo.id,
      device_type: "Web",
      message: "",
      key: roomUser,
      role_id: userInfo.role_id,
      status: 0,
      time: Moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
      epoch: -1 * time,
    };
    // Update local state
    setRoom({ ...room, roomname: roomUser });
    try {
      const db = getDatabase();
      // Mentor’s node
      const mentorRefPath = `users/${item.user_id}/${roomUser}`;
      const mentorRef = ref(db, mentorRefPath);
      const mentorSnap = await get(child(ref(db), mentorRefPath));
      if (!mentorSnap.exists()) {
        await set(mentorRef, message);
      }

      //Mentee’s node
      const menteeRefPath = `users/${userInfo.id}/${roomUser}`;
      const menteeRef = ref(db, menteeRefPath);
      const menteeSnap = await get(child(ref(db), menteeRefPath));
      if (!menteeSnap.exists()) {
        await set(menteeRef, message);
      }
    } catch (error) {
      console.error("Error while creating chat room:", error);
    }
  };

  return (
    <div>
      <section className="community_section">
        <div className="content_inner">
          <img
            src={imgPath + "cm_back.jpg"}
            alt="women leadership mentoring"
            className="img-fluid back_img"
          />
        </div>
      </section>
      <section className="community_page_inner">
        <Container className="container">
          <div className="row_c d-flex">
            <div className="community_content">
              <h1 className="dash_heading">{forum_heading} Forum</h1>
            </div>

            <div className="group_c d-flex align-items-center justify-content-center ms-auto">
              <button
                onClick={(e) => {
                  askQuestionModal(e);
                }}
                className={"mr-3 " + disbaled} style={{ cursor: "pointer" }}
              >{""}
                Ask a Question
              </button>
            </div>
          </div>
          <Row className="mt-4">
            <Col lg="8" md="7">
              <div className="whole_content">
                <div className="forum_page_contant faqouter">
                  <Accordion activeKey={activeId}>
                    {/* {forums && */}
                    {forums.map((item, key) => (
                      <Card key={item.id}>
                        <Card.Header>
                          <Button
                            className={
                              !activeId?.includes(String(key + 1)) && "faq_open"
                            }
                            onClick={() =>
                              setActiveId(
                                activeId?.includes(String(key + 1))
                                  ? activeId?.filter((id) => id !== String(key + 1))
                                  : [...activeId, String(key + 1)]
                              )
                            }
                            style={{
                              width: "100%",
                              textAlign: "left",
                              background: "transparent",
                              border: "none",
                              fontWeight: 600,
                              fontSize: "1.1rem",
                            }}
                          >
                            {item.question}
                          </Button>
                        </Card.Header>

                        <Accordion.Collapse eventKey={String(key + 1)}>
                          <Card.Body>
                            <div className="forum_contant_body">
                              <div className="answer_top_info">
                                <div className="answer_list_left">
                                  <div className="answer_count">
                                    <img
                                      src={imgPath + "message.png"}
                                      alt="Answers"
                                    />{" "}
                                    {item.answers.length} Answers
                                  </div>
                                  <Button
                                    className="btn reply_btn"
                                    onClick={(e) => {
                                      replyAnswerModal(e, item.id, item.user_ans);
                                    }}
                                  >
                                    <i className="fas fa-reply"></i> Reply
                                  </Button>
                                  <Button
                                    className="btn reply_btn report_to_admin w-md-100"
                                    onClick={(e) => {
                                      viewReportModal(e, item.id, "", "question");
                                    }}
                                    title="Report to Admin"
                                  >
                                    Report to Admin
                                  </Button>
                                </div>
                                <span className="timeing">
                                  Asked{" "}
                                  <span className="asked_timing">{item.asked_ago}</span>
                                </span>
                              </div>

                              {item.answers && item.answers.length > 0 && (
                                <>
                                  <h4>Answers</h4>
                                  {item.answers.map((item) => (
                                    <div className="answer_list" key={item.id}>
                                      <div
                                        dangerouslySetInnerHTML={prepareHtml(item.answer)}
                                      ></div>
                                      <div className="answer_bottom">
                                        <div className="answer_list_left">
                                          <Button
                                            className="btn reply_btn report_to_admin answer_report_to_admin"
                                            onClick={(e) => {
                                              viewReportModal(
                                                e,
                                                item.id,
                                                item.id,
                                                "answer"
                                              );
                                            }}
                                            title="Report to Admin"
                                          >
                                            Report to Admin
                                          </Button>
                                          <Button
                                            className="likes_count"
                                            onClick={(e) => {
                                              likeAnswer(item.id, item.id);
                                            }}
                                          >
                                            <i className="fas fa-thumbs-up"></i>{" "}
                                            {item.likes} Likes
                                          </Button>
                                          <div className="posted_by">
                                            <span>Posted By : </span>
                                            {item.posted_by}
                                          </div>
                                        </div>
                                        <span className="timeing">
                                          Posted On :{" "}
                                          <span className="posted_timing">
                                            {item.posted_ago}
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  ))}
                                </>
                              )}
                            </div>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    ))}
                  </Accordion>
                </div>
              </div>
            </Col>

            <Col lg="4" md="5" className="mt-4 mt-md-0">
              <div className="sidebar_community overflow_custom_style">
                <div className="d-flex align-items-center heading justify-content-between mb-4">
                  <h2>Forum Members ({forumusers.length}) </h2>
                </div>

                {/* LIST */}
                {/* {forumusers && */}
                {forumusers.map((item) => (
                  <div className="member_list" key={item.user_id}>
                    <ul>
                      <li className="d-flex align-items-center mb-3">
                        <div className="member_image">
                          {item.image && (
                            <img
                              src={item.image}
                              alt="career coaching for women"
                              className="img-fluid"
                            />
                          )}
                          {!item.image && (
                            <img
                              src={
                                imgPath +
                                "mentor_women_two.png"
                              }
                              className="img-fluid"
                              alt="career mentor consulting"
                            />
                          )}
                        </div>
                        <div className="member_detail ms-3">
                          <h3>{item.full_name}</h3>
                          <h4>{item.position}</h4>
                          <h4>{item.organization}</h4>
                          {userInfo.id !== item.user_id && (
                            <button
                              className="link_btn btn btn_red"
                              onClick={() => handleClickChat(item)}
                            >
                              <img
                                src={
                                  imgPath +
                                  "msg.png"
                                }
                                alt="msg_icon"
                                className="me-2 bg-white"
                              />{""}
                              Send Message
                            </button>
                          )}
                        </div>
                      </li>
                    </ul>
                  </div>
                ))}
                {/* {forumusers &&  */}
                {forumusers.length === 0 && (
                  <div className="text-center">No Joined User found.</div>
                )}
                {/* LIST */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {modalShow && (
        <Question
          show={modalShow}
          userdata={userData}
          onHide={() => setModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}

      {answerShow && (
        <Answer
          show={answerShow}
          userdata={userData}
          refreshForum={() => dispatch(loadForumData(userInfo.id))}
          onHide={() => setAnswerShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}

      {reportModalShow && (
        <ReportAdmin
          show={reportModalShow}
          userdata={userData}
          onHide={() => setReportModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}

      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        // title="Success"
        showConfirm={false}
        staticBackdrop={true}
      />
    </div>
  );
};

export default Index;
